/**
 * Product form: sticky ATC observer
 */
(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function initStickyAtc() {
    var sticky = qs('[data-nw-sticky-atc]');
    if (!sticky || !('IntersectionObserver' in window)) return;
    var buybox = qs('[data-nw-buybox]');
    if (!buybox) return;
    var io = new IntersectionObserver(
      function (entries) {
        var visible = entries.some(function (e) {
          return e.isIntersecting;
        });
        document.body.setAttribute('data-nw-sticky-atc', visible ? 'false' : 'true');
      },
      { rootMargin: '0px', threshold: 0.05 }
    );
    io.observe(buybox);
  }

  function syncStickyVariant() {
    var mainSelect = document.querySelector('[data-nw-variant-select]');
    var sticky = document.querySelector('[data-nw-sticky-atc]');
    if (!mainSelect || !sticky) return;
    var stickyForm = sticky.querySelector('form');
    if (!stickyForm) return;
    var stickyInput = stickyForm.querySelector('input[name="id"]');
    if (!stickyInput) return;
    mainSelect.addEventListener('change', function () {
      stickyInput.value = mainSelect.value;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyAtc();
    syncStickyVariant();
  });
})();
